/**
 * Telas de ENTRADA: quem está nelas ainda não tem sessão aberta (login,
 * recuperação de senha, ativação, primeiro acesso — interno e do portal).
 *
 * Nelas quem fala da manutenção é o aviso grande do login
 * (`AvisoDeManutencaoNoLogin`); a faixa e o diálogo da carência ("seu
 * trabalho será salvo automaticamente") são para quem está logado e, no
 * /login, o diálogo cobria o aviso grande (28/09/2026).
 */
const TELAS_DE_ENTRADA = [
  "/login",
  "/portal/login",
  "/recuperar-senha",
  "/resetar-senha",
  "/activate-account",
  "/primeiro-acesso",
  "/portal/primeiro-acesso",
];

export function ehTelaDeEntrada(pathname: string): boolean {
  const caminho = pathname.replace(/\/+$/, "") || "/";
  return TELAS_DE_ENTRADA.includes(caminho);
}
